let API_HEADER = "../gthmmc/index.php?m=ias&c=manager&";
let API_HEADER2 = "https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=temp&";
let API_HEADER3 =
  "../gthmmc/index.php?m=ias&c=temp&";
/* let API_HEADER = "http://localhost/sajj/gthmmc/index.php?m=ias&c=manager&";
let API_HEADER2 = "http://localhost/sajj/gthmmc/index.php?m=ias&c=temp&";
let API_HEADER3 = "http://localhost/sajj/gthmmc/index.php?m=ias&c=temp&"; */
/* let API_HEADER = "http://192.168.0.187/sajj/gthmmc/index.php?m=ias&c=manager&";
let API_HEADER2 = "http://192.168.0.187/sajj/gthmmc/index.php?m=ias&c=temp&";
let API_HEADER3 = "http://192.168.0.187/sajj/gthmmc/index.php?m=ias&c=temp&"; */
/* let API_HEADER = "https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=manager&";
let API_HEADER2 = "https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=temp&";
let API_HEADER3 =
  "https://sajj.jlntech.cn/sajj/gthmmc/index.php?m=ias&c=temp&"; */
export default {
  departmentLogin: API_HEADER2 + "a=departmentLogin",
  getPointpro: API_HEADER + "a=getPointpro",
  addPointpro: API_HEADER + "a=addPointpro",
  modifyPointpro: API_HEADER + "a=modifyPointpro",
  recyclePointpro: API_HEADER + "a=recyclePointpro",
  getTags: API_HEADER2 + "a=getTags",
  modifyTags: API_HEADER2 + "a=modifyTags",
  getPointlog: API_HEADER3 + "a=getpointlogMember",
  getMember: API_HEADER3 + "a=getMember",
  modifyPointlog: API_HEADER3 + "a=modifypointlog",
  outputpointlogMember: API_HEADER3 + "a=outputpointlogMember",
  getNotice: API_HEADER + "a=getNotice",
  addNotice: API_HEADER + "a=addNotice",
  recycleNotice: API_HEADER + "a=recycleNotice",
  modifyNotice: API_HEADER + "a=modifyNotice",
  recycleMember:API_HEADER3 + "a=recycleMember",
  modifyMember:API_HEADER3 + "a=modifyMember",
  'getVip':API_HEADER+"a=getVip",
  'addVip':API_HEADER+"a=addVip",
  'recycleVip':API_HEADER+"a=recycleVip",
  'modifyVip':API_HEADER+"a=modifyVip",
  'getVipuselog': API_HEADER+"a=getVipuselog",
  "getChangeList":API_HEADER2+"a=getChangeList",
  "executeChange":API_HEADER2+"a=executeChange",
  "recycleChange":API_HEADER2+"a=recycleChange",
};
